import type { AppBranding } from "@atoms/atom-client";

export const projectBranding = {
  appName: "Emerge",
  logo: {
    src: "/emerge3-logo.png",
    alt: "LTCase Logo",
  },
} satisfies AppBranding;
